import React, { useEffect, useState } from "react";
import Layout from "../../component/layout/Layout";
import "./SpecChem.css";
import "aos/dist/aos.css";
import AOS from "aos";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import firebaseConfig from "../firebase/firebaseConfig";

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();

const SpecialityChem = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [cards, setCards] = useState([]);

  const handleSlideChange = (index) => {
    setActiveSlide(index);
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  useEffect(() => {
    const fetchCards = async () => {
      try {
        const snapshot = await db
          .collection("specialtyChemicals")
          .orderBy("orderID")
          .get();
        const fetchedCards = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCards(fetchedCards);
      } catch (error) {
        console.error("Error fetching cards:", error);
      }
    };

    fetchCards();
  }, []);

  return (
    <Layout>
      <section id="hero">
        <div
          id="heroCarousel"
          className="carousel slide carousel-fade"
          data-bs-interval="5000"
          data-bs-ride="carousel"
        >
          <ol className="carousel-indicators" id="hero-carousel-indicators">
            <li
              data-bs-target="#heroCarousel"
              data-bs-slide-to="0"
              className={activeSlide === 0 ? "active" : ""}
              onClick={() => handleSlideChange(0)}
            ></li>
          </ol>
          <div className="carousel-inner" role="listbox">
            <div
              className={`carousel-item ${
                activeSlide === 0 ? "active" : ""
              }`}
              style={{
                backgroundImage: "url(/Carousel/industries-application.svg)",
              }}
            >
              <div className="carousel-container">
                <div className="container">
                  <div className="text" id="text">
                    <h2
                      className="animate__animated animate__fadeInDown"
                      data-aos="fade-down"
                    >
                      Specialty Chemicals
                    </h2>
                    <p
                      className="animate__animated animate__fadeInUp"
                      data-aos="fade-up"
                    >
                      RMC has a wide range of products that encompasses
                      chemicals for various applications in industries like
                      Pharmaceutical, Sugar, Textile, Paper, Metallurgy, Oil &
                      Gas, Mining, etc.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* cards section */}
      <section id="services" className="services">
        <div className="container" data-aos="fade-up">
          <div className="section-title text-center">
            <h1 style={{ textTransform: "capitalize" }}>
              Specialty Chemicals
            </h1>
          </div>
          <br />
          <div className="row md-12">
            {cards.map((card, index) => (
              <div
                className={`col-lg-4 col-md-${
                  index % 2 === 0 ? "12" : "6"
                }`}
                data-aos="zoom-in"
                data-aos-delay={100 * (index % 3)}
                key={card.id}
              >
                <div className="icon-box">
                  <div className="icon-img">
                    <img src={card.image} alt={card.title} />
                  </div>
                  <div className="secton-title">
                    <h4>{card.title}</h4>
                  </div>
                  <p>{card.description}</p>
                  <br />
                  <a
                    href={card.link || "#"}
                    className="get-started-btn"
                  >
                    View Products
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default SpecialityChem;
